import {
  AppBar,
  Box,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { useState, useEffect, ChangeEvent } from "react";
import { useStyles } from "./DocumentGroup.style";
import {
  BoxDialog,
  Container,
  Panel,
  DeleteAlert,
  Pagination,
} from "../../../../../Components";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import DocumentGroupServices from "../../../../../Redux/Actions/DocumentGroup/DocumentGroupAction";
import CustomerServicesApi from "../../../../../Redux/Actions/CustomerAction";
import { CreateDocument } from "./CreateDocument";
import { Edit, Delete } from "@material-ui/icons";
import BuildIcon from "@material-ui/icons/Build";
import { useApiValidationSnackbar } from "../../../../../Components/Snackbar/SnackbarAlert";
import { useSnackbar } from "notistack";
import { SearchTextField } from "../../../../../Components/Field";
import { EditDocument } from "./EditDocument";
import {
  MRT_ShowHideColumnsButton,
  MaterialReactTable,
} from "material-react-table";
import UserSevicesApi from "../../../../../Redux/Actions/UserAction";
import { UserList } from "../../Users/UserList";
import { DocumentMls } from "../../Documents/DocumentMls";
import { GroupDocument } from "../../Group/GroupDocument";
import { useNavigate, useParams } from "react-router-dom";
export const DocumentGroup = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const dispatch: any = useDispatch();
  const [reloadPage, setReload] = useState(false);
  let [permissionButton, setPermissionButton] = useState<any>(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const {
    apiToken,
    allDocumentsGroup,
    currentUser,
    usersPermission,
    groupUsersPermission,
    treeStructureDocument,
  } = useSelector((state: any) => ({
    apiToken: state?.UserReducer?.apiToken,
    allDocumentsGroup: state?.DocumentGroupReducer?.allDocumentsGroup,
    currentUser: state?.UserReducer?.currentUser,
    usersPermission: state.CustomerReducer.usersPermission,
    groupUsersPermission: state.CustomerReducer.groupUsersPermission,
    treeStructureDocument: state?.DocumentGroupReducer?.treeStructureDocument,
  }));
  useEffect(() => {
    let customerId = currentUser?.customerId;
    try {
      dispatch(DocumentGroupServices.allDocumentGroups(customerId, apiToken));
      hierarchicalDocumentFunction();
    } catch (error) {
      console.error(error);
    }
  }, []);
  const hierarchicalDocumentFunction = () => {
    let customerId = currentUser?.customerId;
    dispatch(DocumentGroupServices.documentHierarchical(customerId, apiToken));
  };
  const params: any = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  let [editRowData, setEditRowData] = useState<any>(null);
  const [permissionopen, setPermissionopen] = useState(false);
  const [userAddOpen, UserAddOpen] = useState(false);
  let [group, setGroup] = useState<any>(null);
  let [selected, setSelected] = useState<any>(20);
  const [rowsPerPage, setRowsPerPage] = useState<number>(50);
  let [alertDeleteOpen, setAlertDeleteOpen] = useState<any>(false);
  let [getDocumentsGroup, setGetDocumentsGroup] = useState<any>(null);
  const [rotate, setRotate] = useState(false);
  let [dataTable, setTableData] = useState(
    allDocumentsGroup?.length ? allDocumentsGroup : []
  );
  const { notifySuccess, ErrorMessage } = useApiValidationSnackbar();
  const { enqueueSnackbar } = useSnackbar();
  const [tab, setTab] = useState(0);
  const tabEnum = {
    user: 0,
    permissionGroup: 1,
    folder: 2,
    document: 3,
    0: "user",
    1: "permissionGroup",
    2: "folder",
    3: "document",
  };
  const columns = [
    {
      header: formatMessage({
        id: "group.user.groupName",
        defaultMessage: "Groups name",
      }),
      accessorKey: "name",
    },
    {
      header: formatMessage({
        id: "group.user.description",
        defaultMessage: "Description",
      }),
      accessorKey: "description",
    },
    {
      header: formatMessage({
        id: "group.user.noOfDocuments",
        defaultMessage: "Groups",
      }),
      accessorKey: "number",
      Cell: (rowData: any) => {
        return (
          <div
            style={{ justifyContent: "center", display: "flex", width: "30%" }}
          >
            {rowData?.row?.original?.documents?.length}
          </div>
        );
      },
      editable: () => {
        return false;
      },
    },
  ];

  const closeBOx = () => {
    setReload(false);
    setOpen(false);
  };
  const editCloseBOx = () => {
    setReload(false);
    setEditOpen(false);
  };
  const closeperBox = () => setPermissionopen(false);
  const permission = (user: any) => ({
    tooltip: formatMessage({
      id: "group.user.editPermission",
      defaultMessage: "Edit Permission",
    }),
    icon: () => <BuildIcon />,
    onClick: () => {
      let customerId = user?.id;
      let DOCUMENT_GROUPS = `document-groups/`;
      setPermissionopen(true);
      dispatch(
        CustomerServicesApi?.getUsersPermission(
          DOCUMENT_GROUPS,
          customerId,
          apiToken,
          enqueueSnackbar
        )
      );
      dispatch(
        CustomerServicesApi?.getUsersGroupPermission(
          DOCUMENT_GROUPS,
          customerId,
          apiToken
        )
      );
      setPermissionButton(user);
    },
  });
  const deleteGroups = (user: any) => {
    return {
      tooltip: formatMessage({
        id: "component.mtable.deleteTooltip",
        defaultMessage: "delete",
      }),
      icon: "delete",
      onClick: () => {
        setAlertDeleteOpen(true);
        setGetDocumentsGroup(user);
      },
    };
  };
  const editDocumentGroups = (user: any) => {
    return {
      tooltip: formatMessage({
        id: "component.mtable.editTooltip",
        defaultMessage: "edit",
      }),
      icon: "edit",
      onClick: () => {
        setEditOpen(true);
        setEditRowData(user);
      },
    };
  };
  const addUserGroup = () => {
    UserAddOpen(false);
  };
  useEffect(() => {
    if (params.tab) {
      setTab(tabEnum[params?.tab]);
    }
  }, [params]);
  useEffect(() => {
    if (tab == tabEnum["user"]) {
      try {
        dispatch(
          UserSevicesApi.UserListData(
            currentUser?.customerId,
            apiToken,
            enqueueSnackbar
          )
        );
      } catch (error) {
        console.error(error);
      }
    }
  }, [tab]);
  useEffect(() => {
    allDocumentsGroup?.map((item: any) => setGroup(item));
    setTableData(allDocumentsGroup?.length ? allDocumentsGroup : []);
  }, [allDocumentsGroup]);
  const onhandleChange = (event: any) => {
    setSelected(event?.target?.value);
    let customerId = event?.target?.value;
    dispatch(DocumentGroupServices.allDocumentGroups(customerId, apiToken));
  };
  const reloadTable = () => {
    dispatch(
      DocumentGroupServices.allDocumentGroups(currentUser?.customerId, apiToken)
    );
    const success: any = "download";
    notifySuccess(allDocumentsGroup, success);
    setReload(false);
  };
  const reloadCreate = () => {
    dispatch(
      DocumentGroupServices.allDocumentGroups(currentUser?.customerId, apiToken)
    );
    setReload(false);
  };
  const setReloadTable = () => {
    setReload(true);
  };
  const createGroupModel = () => setOpen(true);
  const deleteDocumentGroup = () => {
    let DOCUMENT_GROUPS = `document-groups/`;
    if (getDocumentsGroup?.documents?.length != 0) {
      enqueueSnackbar(
        formatMessage({ id: "document.document.group.remove.message" }),
        { variant: "error" }
      );
      setAlertDeleteOpen(false);
    } else {
      dispatch(
        CustomerServicesApi?.getUsersPermission(
          DOCUMENT_GROUPS,
          getDocumentsGroup?.id,
          apiToken,
          enqueueSnackbar
        )
      );
      dispatch(
        CustomerServicesApi?.getUsersGroupPermission(
          DOCUMENT_GROUPS,
          getDocumentsGroup?.id,
          apiToken
        )
      );
      setGroup(getDocumentsGroup);
      setTimeout(() => {
        if (usersPermission?.length > 0 || groupUsersPermission?.length > 0) {
          enqueueSnackbar(
            formatMessage({ id: "document.document.group.error.message" }),
            { variant: "error" }
          );
          setAlertDeleteOpen(false);
        } else {
          setTimeout(() => {
            const index = getDocumentsGroup?.id;
            setReloadTable();
            dispatch(
              DocumentGroupServices?.deleteDocumentsGroup(index, apiToken)
            );
          }, 1000);
          setTimeout(() => {
            reloadTable();
            setAlertDeleteOpen(false);
          }, 2000);
        }
      }, 1000);
    }
  };

  const [searchData, setSearchData] = useState("");
  let searchHandle = (str: string) => {
    setSearchData(str);
    if (str) {
      let myData = allDocumentsGroup?.filter((item: any) => {
        let findNameData = item.name.toLowerCase().includes(str.toLowerCase());
        let documentData = item.documents?.filter((val: any) =>
          val.name.toLowerCase().includes(str.toLowerCase())
        );
        return findNameData || documentData.length > 0;
      });
      setTableData(myData);
    } else {
      setTableData(allDocumentsGroup?.length ? allDocumentsGroup : []);
    }
  };
  const downloadFile = (rowData: any) => {
    dispatch(
      CustomerServicesApi?.downloadFile(
        rowData,
        apiToken,
        notifySuccess,
        ErrorMessage
      )
    );
  };
  const { pagination, toolbar, body } = Pagination();
  const handleChangeRowsPerPage = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value));
  };
  interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
  }
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  return (
    <div className={`Document-group-page ${classes.root}`}>
      <Container fullWidth>
          <Panel
            titleKey="tab.folder"
            titleValues={"modelButton"}
            buttonTitle={"createDocument.btn"}
            handleOpen={createGroupModel}
          >
            <div className="Document-group-table">
              <MaterialReactTable
                columns={columns}
                data={dataTable}
                enableExpanding
                getSubRows={(originalRow: any) => originalRow.children}
                enableRowActions
                positionActionsColumn={"last"}
                localization={{
                  actions: formatMessage({ id: "component.mtable.actions" }),
                  noRecordsToDisplay: formatMessage({
                    id: "component.mtable.emptyDataSourceMessage",
                  }),
                }}
                initialState={{
                  pagination: {
                    pageIndex: 0,
                    pageSize: 50,
                  },
                }}
                displayColumnDefOptions={{
                  "mrt-row-actions": {
                    muiTableHeadCellProps: {
                      align: "right",
                    },
                  },
                }}
                renderRowActions={({ row, table }) => (
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                      gap: "7px",
                    }}
                  >
                    <Tooltip
                      title={formatMessage({
                        id: "group.user.editPermission",
                        defaultMessage: "Edit Permission",
                      })}
                    >
                      <IconButton
                        style={{ padding: 0, color: "black" }}
                        onClick={() => {
                          let customerId = row?.original?.id;
                          let DOCUMENT_GROUPS = `document-groups/`;
                          setPermissionopen(true);
                          dispatch(
                            CustomerServicesApi?.getUsersPermission(
                              DOCUMENT_GROUPS,
                              customerId,
                              apiToken,
                              enqueueSnackbar
                            )
                          );
                          dispatch(
                            CustomerServicesApi?.getUsersGroupPermission(
                              DOCUMENT_GROUPS,
                              customerId,
                              apiToken
                            )
                          );
                          setPermissionButton(row.original);
                        }}
                      >
                        <BuildIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip
                      title={formatMessage({
                        id: "component.mtable.deleteTooltip",
                        defaultMessage: "delete",
                      })}
                    >
                      <IconButton
                        style={{ padding: 0, color: "black" }}
                        onClick={() => {
                          setAlertDeleteOpen(true);
                          setGetDocumentsGroup(row.original);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                    <Tooltip
                      title={formatMessage({
                        id: "component.mtable.editTooltip",
                        defaultMessage: "edit",
                      })}
                    >
                      <IconButton
                        style={{ padding: 0, color: "black" }}
                        onClick={() => {
                          console.log(row, "dndkdn");
                          setEditOpen(true);
                          setEditRowData(row.original);
                        }}
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}
                muiTablePaginationProps={{
                  showFirstButton: true,
                  showLastButton: true,
                  rowsPerPageOptions: [5, 10, 20, 50, 100],
                  labelRowsPerPage: formatMessage({
                    id: "component.mtable.labelRowsPerPage",
                    defaultMessage: "Row Per Page",
                  }),
                }}
                renderTopToolbar={({ table }) => (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      padding: "10px 20px 12px 0px",
                    }}
                  >
                    <Box style={{ width: 250 }}>
                      <SearchTextField
                        onChange={searchHandle}
                        value={searchData}
                        clearSearch={() => {
                          setSearchData("");
                          setTableData(
                            allDocumentsGroup?.length ? allDocumentsGroup : []
                          );
                        }}
                      />
                    </Box>
                    <Box>
                      <MRT_ShowHideColumnsButton table={table} />
                    </Box>
                  </Box>
                )}
                enableHiding={true}
                enableFilters={false}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                renderBottomToolbarCustomActions={() => (
                  <Typography style={{ fontWeight: "bold", marginLeft: 12 }}>
                    {formatMessage({
                      id: "component.mtable.total",
                      defaultMessage: "Total",
                    })}{" "}
                    {dataTable.length}
                  </Typography>
                )}
                renderDetailPanel={({ row }) => {
                  return (
                    <>
                      {row?.original?.documents?.map((items: any, i: any) => (
                        <Grid
                          key={i}
                          container
                          justifyContent="space-between"
                          className={
                            i == 0
                              ? classes.panelContainer1
                              : classes.panelContainer2
                          }
                        >
                          <Grid className={classes.panelRow}>
                            {items?.name}
                          </Grid>
                          <Grid
                            className={classes.panelUrl}
                            onClick={() => downloadFile(items)}
                          >
                            {items?.url}{" "}
                          </Grid>
                        </Grid>
                      ))}
                    </>
                  );
                }}
              />
            </div>
          </Panel>
          </Container>
        {alertDeleteOpen && (
          <DeleteAlert
            alertClose={() => setAlertDeleteOpen(false)}
            alertOpen={alertDeleteOpen}
            componentName={"document.sidebar.group"}
            Submited={deleteDocumentGroup}
            deletedValue={getDocumentsGroup?.name}
            deletedDocumentData={getDocumentsGroup}
            allDocumentsGroup={allDocumentsGroup}
          />
        )}
        {permissionopen && (
          <BoxDialog
            open={permissionopen}
            handleClose={closeperBox}
            selectdata={permissionButton}
            url={`document-groups/`}
            document={"documentGroupPermission"}
            columnName={"group"}
          />
        )}
        {open && (
          <CreateDocument
            handleClose={closeBOx}
            open={open}
            addopen={userAddOpen}
            addUserClose={addUserGroup}
            group={group}
            data={treeStructureDocument}
            forceReload={reloadCreate}
            setReload={setReloadTable}
            hierarchicalDocumentFunction={() => {
              hierarchicalDocumentFunction();
            }}
          />
        )}
        {editOpen && (
          <EditDocument
            editHandleClose={editCloseBOx}
            editOpen={editOpen}
            editRowData={editRowData}
            data={treeStructureDocument}
          />
        )}
     
    </div>
  );
};
